module.exports = __webpack_public_path__ + "img/network.50ece7f0.png";